import {
  frontPassportNew,
  backPassportNew,
  documentIcon,
  frontPassportOld,
  backPassportOld,
  innIcon,
} from '../shared/images/icons';
//set icons into drag and drop zone
export const setIconDragAndDrop = (type) => {
  switch (type) {
    case 'new-front':
      return frontPassportNew;
    case 'new-back':
      return backPassportNew;
    case 'document':
      return documentIcon;
    case 'old-front':
      return frontPassportOld;
    case 'old-back':
      return backPassportOld;
    case 'inn':
      return innIcon;
    default:
      return null;
  }
};
//make new names for files
export const fileNameMaker = (mymetype, type, size) => {
  switch (mymetype) {
    case 'image/jpeg':
      return `${size}-${parseInt(Math.random() * 100)}_document.jpg`;
    case 'application/pdf':
      return `${size}-${parseInt(Math.random() * 100)}_document.pdf`;
    case 'image/png':
      return `${size}-${parseInt(Math.random() * 100)}_document.png`;
    default:
      return parseInt(Math.random() * 100000000) + '_document' + mymetype;
  }
};

export const blenderName = (name) => {
  const z = Array.from(name);
  name = z.map(function (o, index) {
    if (index === 0) {
      return o.toUpperCase();
    } else if (index === z.length - 1) {
      return o.toUpperCase();
    } else {
      return '*';
    }
  });
  return name;
};
export function checkStorage() {
  const smsLimit = localStorage.getItem('smsLimit');
  if (smsLimit) {
    return;
  } else {
    localStorage.setItem('smsLimit', { smsCount: 0, time: new Date() });
    return;
  }
}
export function setToLocalStorage() {
  const { smsCount } = localStorage.getItem('smsLimit');
  if (Number(smsCount) !== 3) {
    localStorage.setItem('smsLimit', {
      smsCount: smsCount + 1,
      time: new Date(),
    });
    return true;
  } else if (smsCount === 3) {
    return false;
  }
}
export function removeFromStorage() {
  const timeNow = new Date();
  const timeOut = timeNow - 1;
  if (timeOut) {
    localStorage.removeItem('smsLimit');
  }
}
export function canSendFiles(data, selectedPassportType, iSForMobi) {
  if (iSForMobi) {
    let pass1 = data.find((o) => o.type === 'new_pass_front');
    let pass2 = data.find((o) => o.type === 'new_pass_back');
    if (pass1 || pass2) {
      return true;
    }
    return;
  }
  if (selectedPassportType === 2) {
    let pass1 = data.find((o) => o.type === 'old_pass_front');
    let pass2 = data.find((o) => o.type === 'old_pass_back');
    let inn = data.find((o) => o.type === 'inn_document');
    if (pass1 && pass2 && inn) {
      return true;
    }
  }
  if (selectedPassportType === 1) {
    let pass1 = data.find((o) => o.type === 'new_pass_front');
    let pass2 = data.find((o) => o.type === 'new_pass_back');

    if (pass1 && pass2) {
      return true;
    }
  }
  return false;
}
